import React from "react";
import InvoiceRow from "./InvoiceRow";

const InvoicesTable = ({ customer_id, invoices }) => {
  const renderInvoices = () => {
    if (!Array.isArray(invoices))
      return <div className="spinner-border" role="status" />;
    if (invoices.length === 0)
      return <p className="small">No hay cargos registradas.</p>;

    invoices.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return dateB - dateA;
    });

    return (
      <div className="table-responsive">
        <table className="table border" style={{ minHeight: "150px" }}>
          <thead className="bg-light border bold small">
            <tr>
              <td>#ID</td>
              <td>#Compra</td>
              <td>Fecha</td>
              <td>Paquete</td>
              {!customer_id && <td>Cliente</td>}
              <td>Total</td>
              <td>Estado</td>
              <td>Sig. Cargo</td>
              <td colSpan={2}>Pago</td>
              <td>Acciones</td>
            </tr>
          </thead>
          <tbody>
            {invoices.map((invoice) => (
              <InvoiceRow
                key={invoice.invoice_id}
                invoice={invoice}
                customer_id={customer_id}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return <div>{renderInvoices()}</div>;
};

export default InvoicesTable;
